import { graphql } from '@prophecy/graphql-types/graphql';
export const UpdatePasswordQuery = graphql(`
  mutation changePassword($currentPassword: String!, $newPassword: String!) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword)
  }
`);
export const DeleteAccountCleanupQuery = graphql(`
  query CleanupPreview {
    cleanupPreview {
      _id
      entityKind
      name
    }
  }
`);
/*
 * @deprecated - use this instead: deleteUserAccount
 */
export const DeleteAccountQuery = graphql(`
  mutation cleanup {
    cleanup {
      entityKind
    }
  }
`);
export const AddUserAttributeQuery = graphql(`
  mutation addUserAttribute($uid: String!, $attribute: UserAttributeType!) {
    addUserAttribute(uid: $uid, attribute: $attribute)
  }
`);
export const DeleteUserAttributeQuery = graphql(`
  mutation deleteUserAttribute($uid: String!, $attribute: UserAttributeType!) {
    deleteUserAttribute(uid: $uid, attribute: $attribute)
  }
`);
